module.exports = __webpack_public_path__ + "cac71bc126cc4bf78aab25094c6e38eb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-32.png
// module id = 2577
// module chunks = 0